.skeleton {
  display: block;
  border-radius: var(--radius-sm);
  background: linear-gradient(
    90deg,
    var(--bg-inset) 0%,
    var(--bg-hover) 40%,
    var(--bg-inset) 80%
  );
  background-size: 300% 100%;
  animation: ela-shimmer 1.4s ease-in-out infinite;
}

.text {
  height: 0.85em;
  margin: 0.2em 0;
}
